// 日本の祝日（国民の祝日に関する法律。2022 年以降の決まりで計算する）。春分・秋分は国立天文台の近似式。
// 定期便の「祝日は走らない」に使う。法律が変わったり特別な祝日ができたら、ここを直す
const ymd = (y: number, m: number, d: number) => `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
/** その月の第 n 月曜日 */
const nthMonday = (y: number, m: number, n: number) => { const first = new Date(Date.UTC(y, m - 1, 1)).getUTCDay(); return 1 + ((8 - first) % 7) + (n - 1) * 7; };
const shift = (s: string, n: number) => new Date(Date.parse(`${s}T00:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10);
const dow = (s: string) => new Date(`${s}T00:00:00Z`).getUTCDay();

const cache = new Map<number, Set<string>>();
export function jpHolidays(y: number): Set<string> {
  const hit = cache.get(y);
  if (hit) return hit;
  const k = y - 1980;
  const spring = Math.floor(20.8431 + 0.242194 * k - Math.floor(k / 4));
  const autumn = Math.floor(23.2488 + 0.242194 * k - Math.floor(k / 4));
  const base = [
    ymd(y, 1, 1), ymd(y, 1, nthMonday(y, 1, 2)), ymd(y, 2, 11), ymd(y, 2, 23), ymd(y, 3, spring), ymd(y, 4, 29),
    ymd(y, 5, 3), ymd(y, 5, 4), ymd(y, 5, 5), ymd(y, 7, nthMonday(y, 7, 3)), ymd(y, 8, 11), ymd(y, 9, nthMonday(y, 9, 3)),
    ymd(y, 9, autumn), ymd(y, 10, nthMonday(y, 10, 2)), ymd(y, 11, 3), ymd(y, 11, 23),
  ];
  const set = new Set(base);
  // 国民の休日：祝日にはさまれた平日
  for (const d of base) { const next = shift(d, 2); if (set.has(next) && !set.has(shift(d, 1)) && dow(shift(d, 1)) !== 0) set.add(shift(d, 1)); }
  // 振替休日：日曜の祝日のあと、最初の祝日でない日
  for (const d of [...set].sort()) if (dow(d) === 0) { let n = shift(d, 1); while (set.has(n)) n = shift(n, 1); set.add(n); }
  cache.set(y, set);
  return set;
}
export const isJpHoliday = (s: string) => jpHolidays(Number(s.slice(0, 4))).has(s);
